import * as angular from 'angular';
import { CacheService } from './CacheService';
export const cache = angular
    .module('cache', [])
    .service('CacheService', CacheService).name;
